import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'

import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../utils/global'
import { loadLocationWithMessage } from '../../actions/location'
import NavBarFittbd from "../../components/structure/NavBarFittbd"
import Background from '../../images/title-contact.jpg'
import Announcement from "../structure/announcement"
import FittBdBrochure from "../structure/announcement"

class OurClinic2 extends Component {
  constructor() {
      super()
      this.state = {
          status: false,
          title: '',
          banner_title: '',
          body: '',
      }
  }

  componentDidMount() {
    this.getContent()
  }

  getContent = () => {
    var banner_title = 'Our Clinic'
    var getData = []
    var get_uri2 = this.props.match.params.page
    if(get_uri2 == 'fitt-bd') {
      banner_title = 'Specialty Clinic: FITT-BD'
      getData = this.getFITTBD()
    } else if(get_uri2 == 'consultations') {
      banner_title = 'Consultations & Ongoing Care'
      getData = this.getConsultations()
    } else if(get_uri2 == 'fitt-bd-brochure') {
      banner_title = 'Introduction to FITT-BD'
      getData = this.getIntroductionFittBD()
    } else if(get_uri2 == 'faq') {
      banner_title = 'FAQs'
      getData = this.getFAQs()
    }

    this.setState({
      title: getData[0],
      banner_title: banner_title,
      body: ReactHtmlParser(getData[1]),
    })
  }

  getFITTBD = () => {
    var getData = ['', '']
    getData[0] = ''
    getData[1] = '<p><div class="row"><div class="col-md-6 order-1"><img src="/files/DCBI_2026_2.jpg" /></div>'
    getData[1] += '<div class="col-md-6 order-2"><img src="/files/DCBI_2026_1.jpg" /></div></div></p>'
    getData[1] += '<p>The Focused Integrated Team-based Treatment Program for Bipolar Disorder (FITT-BD) is the specialty outpatient clinic at the Dauten Family Center for Bipolar Treatment Innovation at Massachusetts General Hospital. This short-term program (six months to a year) is designed to help people with bipolar disorder gain the skills and understanding they need to independently manage their condition. <a href="/our-clinic-/fitt-bd-brochure">Click here for an <b>Introduction to FITT-BD.</b></a></p>'
    getData[1] += '<p>At the FITT-BD clinic, we strive to treat every patient holistically, considering such things as exercise and sleep, as well as actively engaging the support of family and friends. All of our providers have expertise in treating people with bipolar disorder and are involved in research to identify more effective treatments for this condition.</p>'
    getData[1] += '<p>The FITT-BD program is currently accepting new patients. If you are interested in joining the program, please call us at 617-643-9185. Note that you must be a resident of Massachusetts to participate in the program. To learn more, please call us at 617-643-9185, or email us at fitt-bd@mgh.harvard.edu."</p>'
    return getData
  }

  getConsultations = () => {
    var getData = ['', '']
    getData[0] = 'Specialist Consultations'
    getData[1] = '<p>We offer one-time, 60- to 90-minute consultations with one of our psychiatrists. Consultations are available in person or virtually for patients located in Massachusetts. Out-of-state patients may travel to Massachusetts for a consultation.</p>'
               + '<p>During this visit, the psychiatrist will:</p>'
               + '<p><ul><li>Review patient’s medical and psychiatric history</li>'
               + '<li>Assess current symptoms</li>'
               + '<li>Discuss any prior diagnosis and treatment</li>'
               + '<li>Provide a diagnosis</li>'
               + '<li>Offer recommendations for treatment</li></ul></p>'
               + '<p>Recommendations are shared with the patient’s referring clinician if the patient desires.</p>'
               + '<p><b>Please note that there is currently a waitlist for consults.</b> If you are interested in being added to the waitlist, or if you are a clinician wanting to make a referral, you can leave a voicemail at 617-643-2076 on weekdays between 9:00 am and 5:00 pm EST. We will get back to you within two business days. MGB referrals are prioritized.</p>'
               + '<p></p>'
               + '<p><h3>Ongoing Medication Management</h3></p>'
               + '<p>In addition to consultations, our center also offers ongoing medication management for bipolar disorder. Patients must reside in Massachusetts and be over the age of 18. Patients who require continued psychiatric care may be able to receive follow-up appointments. Availability for ongoing care varies depending on clinician capacity.</p>'
               + '<p><b>Please note that there is currently a waitlist for ongoing medication management.</b> If you are interested in being added to the waitlist, or if you are a clinician wanting to make a referral, you can leave a voicemail at 617-643-2076 on weekdays between 9:00 am and 5:00 pm EST. We will get back to you within two business days. MGB referrals are prioritized.</p>'
               + '<p></p>'
               + '<p></p>'
               + '<p></p>'
               + '<p></p>'
               + '<p></p>'
               + '<p></p>'
               + '<p></p>'
               + '<p></p>'
               + '<p></p>'
    return getData
  }

  getIntroductionFittBD = () => {
    var getData = ['', '']
    getData[0] = ''
    getData[1] = '<iframe allowfullscreen="allowfullscreen" allow="clipboard-write" scrolling="no" class="fp-iframe" src="https://heyzine.com/flip-book/864fff8061.html" style="border: 1px solid lightgray; width: 100%; min-height: 351px; height: auto;"></iframe>'
    return getData
  }

  getFAQs = () => {
    var getData = ['', '']
    getData[0] = ''
    getData[1] = '<p><h2>Frequently Asked Questions</h2>'
               + '<h5>How long is the FITT-BD program?</h5>'
               + '<p>FITT-BD is a short-term program. The typical duration is between six months and one year, depending on your individual treatment needs and progress.</p>'
               + '<h5>How is FITT-BD different from other bipolar treatment programs?</h5>'
               + '<p>FITT-BD is unique in its focus on need-based care, collaboration, and the use of an online platform for tracking progress. It offers a flexible, personalized treatment experience, rather than relying solely on traditional therapy sessions.</p>'
               + '<h5>Can I participate in FITT-BD if I’m already receiving treatment elsewhere? </h5>'
               + '<p>Yes, FITT-BD can complement your existing treatment plan. You must have a psychiatrist, PCP, or other prescriber to enroll. FITT-BD will work with you and your current providers to provide the right care for your needs.</p>'
               + '<h5>What kinds of goals can I set in FITT-BD? </h5>'
               + '<p>Your goals can be anything that is meaningful to you. Examples include:<p/>'
               + '<p><ul><li>Returning to school or work</li>'
               + '<li>Doing more activities that bring you joy</li>'
               + '<li>Managing mood swings better</li></ul></p>'
               + '<h5>What happens if my goals change during the program? </h5>'
               + '<p>Your treatment plan is flexible and can be adjusted as your goals evolve. Regular meetings with your team allow for ongoing communication, so if your goals change, your treatment plan can be updated to reflect those changes.</p>'
               + '<h5>How often will I meet with my treatment team? </h5>'
               + '<p>You will meet with your treatment team regularly, depending on your individual treatment plan. This could include group sessions, check-ins with clinicians, and periodic assessments of your goals and progress. The frequency of these meetings will be adjusted as your needs change.</p>'
               + '<h5>How is the treatment plan created?</h5>'
               + '<p>After your intake appointment, you will work with a clinician to develop a plan that aligns with your personal goals and the level of support you need. This plan will evolve as you progress, with regular reviews to ensure it continues to meet your needs.</p>'
               + '<h5>Will I be required to attend in-person appointments?</h5>'
               + '<p>No, the FITT-BD program is completely virtual.</p>'
               + '<h5>Do I need to complete the online assessments?</h5>'
               + '<p>Yes, as part of the FITT-BD program, you will track key areas such as mood, sleep, and exercise using the FITT-BD online platform. Completing weekly and monthly questionnaires will help both you and your team monitor progress, identify patterns, and adjust your treatment plan as needed.</p>'
               + '<h5>What is the role of the peer specialist?</h5>'
               + '<p>A peer specialist is someone who has lived experience with bipolar disorder and provides support and guidance from a perspective of shared understanding. They are a valuable resource to help you feel more connected and supported throughout your treatment.</p>'
               + '<h5>What is the role of the patient navigator?</h5>'
               + '<p>Your patient navigator is there to help you understand the process, answer technical questions, and make sure you have everything you need at each stage of the program.</p>'
               + '<h5>What is expected of me? </h5>'
               + '<p>As a patient in the FITT-BD program, you will actively engage in the program by setting goals, tracking your progress using our online platform, and attending treatment sessions (such as group work, online courses, and individual skills training).</p>'
               + '<h5>Is FITT-BD covered by insurance?</h5>'
               + '<p>FITT-BD is covered by most insurances accepted at MGB, but coverage can vary depending on your plan. It’s recommended that you check with your insurance provider to understand what the cost might be for joining the program.</p>'
               + '<h5>What happens if I don’t feel like FITT-BD is right for me? </h5>'
               + '<p>If at any point you feel that FITT-BD isn’t the right fit for you, you can discuss your concerns with your treatment team. Together, you can evaluate your progress and explore other options that may be better suited to your needs.</p></p>'
    return getData
  }

  render() {
    var sectionStyle = {
      backgroundColor: 'rgba(0,52,86,1.00)',
      padding: '3% 0% 3% 0%',
      color: 'rgba(255,255,255,1.0)',
      backgroundImage: `url(${Background})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    };
    return (
    <div>
      <div className="container-fluid sectionTitle" style={ sectionStyle }>
        <div className="row">
          <div className="col-md-10 offset-md-1 col-sm-12 offset-sm-0">
            <h1>{this.state.banner_title}</h1>
          </div>
        </div>
      </div>
      <div className="container-fluid sectionBody">
        <div className="row">
          <div className="col-lg-3 offset-lg-1 col-md-10 offset-md-1 order-lg-1 order-2 sideBar">
            <NavBarFittbd loggedIn={this.state.loggedIn} />
          </div>
          <div className="col-lg-7 offset-lg-0 col-md-10 offset-md-1 col-sm-12 offset-sm-0 order-lg-2 order-1 px-3 pageBody">
            {this.state.title && <h3>{this.state.title}</h3>}
            {this.state.body}
          </div>
        </div>
      </div>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(OurClinic2)
